import React, { PropsWithChildren, createContext, useMemo } from "react";
import { Store } from "@wss/store";
import { ChromeBarState, ViewSetting } from "./useChromeBarComponentStore";

interface Props {
  chromeBarStore: Store<ChromeBarState>;
}

interface ChromeBarContextType {
  view: ViewSetting;
}

export const ChromeBarContext = createContext<ChromeBarContextType>({
  view: "grid",
});

const ChromeStoreContextProvider = ({
  chromeBarStore,
  children,
}: PropsWithChildren<Props>) => {
  const view = chromeBarStore.useState((state) => state.view);
  const contextValue = useMemo(
    () => ({
      view,
    }),
    [view],
  );

  return (
    <ChromeBarContext.Provider value={contextValue}>
      {children}
    </ChromeBarContext.Provider>
  );
};

export default ChromeStoreContextProvider;
